import { Component, OnInit } from "@angular/core";

@Component({
    standalone: false,
    selector: 'app-account-settings',
    templateUrl: './account-settings.component.html',
    styleUrls: ['./account-settings.component.scss']
})
export class AccountSettingsComponent implements OnInit { 
    constructor(){}
    ngOnInit(): void {}
}